import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle } from "underscore";


Snappy.Component.MouseoverArrow = class MouseoverArrow extends Snappy.BaseComponent {
    static get tagName() {
        return 'mouseover-arrow';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onResize();

        this.$arrowLeft.addClass('mouseover-arrow mouseover-arrow--left');
        this.$arrowRight.addClass('mouseover-arrow mouseover-arrow--right');

    }

    setVars() {
        this.$document = $(document);
        this.$arrowLeft = this.$element.find('.js-arrow-left');
        this.$arrowRight = this.$element.find('.js-arrow-right');
        this.$arrows = this.$arrowLeft.add(this.$arrowRight);

        this.sens = 0.20; //part of container width arrows appears mouseover on

    }
    setEventListeners() {
        this.$element.on(
            'mousemove',
            throttle(this.mouseMoveHandler.bind(this), 200)
        );

        this.$element.on(
            'mouseleave',
            this.mouseLeaveHandler.bind(this)
        );

        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );
    }

    mouseMoveHandler(e) {
        const containerWidth = this.width;
        const x = e.clientX;
        if (x < this.containerLeft + this.sensOffset) {
            this.$arrowLeft.addClass('is-active');
            this.$arrowRight.removeClass('is-active');
        } else if (x > this.containerLeft + this.width - this.sensOffset ) {
            this.$arrowLeft.removeClass('is-active');
            this.$arrowRight.addClass('is-active');
        } else {
            this.$arrowLeft.removeClass('is-active');
            this.$arrowRight.removeClass('is-active');
        }
    }

    mouseLeaveHandler(e) {
        setTimeout(() => {
            this.$arrows.removeClass('is-active');
        }, 200);
    }

    onResize() {
        this.width = this.$element.outerWidth();
        const rect = this.$element[0].getBoundingClientRect();
        this.containerLeft = rect.left;
        this.sensOffset = this.sens * this.width;
    }

}



// WEBPACK FOOTER //
// ./components/mouseover-arrow/scripts/mouseover-arrow.js